// @ts-nocheck
import React from 'react';
import dayjs from 'dayjs';
import { ConfirmDeleteDialog } from '../../../components/ConfirmDeleteDialog';
import type { Deployment } from '../../../api/deploymentsApi';

interface DeploymentDeleteDialogProps {
  deployment: Deployment | null;
  open: boolean;
  loading?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

export const DeploymentDeleteDialog = ({
  deployment,
  open,
  loading = false,
  error = null,
  onConfirm,
  onClose,
}: DeploymentDeleteDialogProps) => {
  if (!deployment) return null;

  const dates = `${dayjs(deployment.start_date).format('DD/MM/YYYY')}${
    deployment.end_date
      ? ` → ${dayjs(deployment.end_date).format('DD/MM/YYYY')}`
      : ''
  }`;

  return (
    <ConfirmDeleteDialog
      open={open}
      title="Supprimer ce déploiement ?"
      description="Cette action est définitive. Le déploiement suivant sera supprimé :"
      details={[
        { label: 'Nom', value: deployment.name, emphasis: true },
        { label: 'Service Desk', value: `SD ${deployment.service_desk_id}` },
        { label: 'Dates', value: dates },
      ]}
      loading={loading}
      error={error}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
